/* eslint-disable @typescript-eslint/naming-convention */
export enum ModuleAreaId {
  ss = 1,
  jtf = 2,
  gym = 3,
  wdyk = 4,
  ks = 5,
  bonus = 6,
  mw = 7,
  k2 = 8,
  vif = 9,
  ct = 10,
}
/* eslint-enable @typescript-eslint/naming-convention */

export enum PermissionChangeType {
  Grant = 0,
  Revoke = 1,
}

export enum Locale {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  US = 0,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  IN = 1,
}

export enum MembershipCardType {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  QRCode = 0,
  ParentLetter = 1,
}

export enum QuestStatus {
  Completed = 'Completed',
  Active = 'Active',
  Locked = 'Locked',
}

export enum BadgeSlug {
  // Sticker badges
  Stickers = 'stickers-',
  Stickers1000 = '1000',
  Stickers2000 = '2000',
  Stickers3000 = '3000',
  Stickers4000 = '4000',
  Stickers5000 = '5000',
  Stickers6000 = '6000',
  Stickers8000 = '8000',
  Stickers10000 = '10000',
  Stickers200Week = 'stickers-200-week',

  // Skill sets
  CompleteSs = 'complete-ss',

  // Just the Facts
  CompleteJtf = 'complete-jtf',

  // Gym badges
  CompleteGym = 'complete-gym',
  GymAdd = 'add',
  GymSub = 'sub',
  GymMul = 'mul',
  GymDiv = 'div',

  // KAS and Milestone badges
  Kas = 'kas-',
  Milestone = 'milestone',

  // Game badges
  CompleteMwGame = 'complete-mw-game',
  CompleteBonus = 'complete-bonus',
  CompleteCt = 'complete-ct',

  // Special badges
  WinPotd = 'win-potd',
  TopTen = 'top-ten',
  TryRpcEpic = 'try-rpc-epic',
}

export enum AssessmentType {
  Summary = 0,
  GoalsIndex = 1,
  GoalsAlgebra = 2,
  Activity = 3,
  Gyms = 4,
  SkillSets = 5,
  KnowAndShow = 6,
  Early = 7,
  Bonuses = 8,
  ComputationalThinking = 9,
  MeasurementWorld = 10,
  JustTheFacts = 11,
  WhatDoYouKnow = 12,
  VeryImportantFacts = 13,
  AllGames = 14,
  FluencyGames = 15,
  WhatDoYouKnow2 = 16,
}

export enum LoginType {
  NotLoggedIn = 0,
  SalesRep = 1,
  RegionAdmin = 2,
  DistrictAdmin = 3,
  TeamLeader = 4,
  StudentPlayer = 5,
  SchoolPrincipal = 6,
  IndividualPlayer = 8,
  Multi = 19,
  LimitedAdmin = 98,
  Admin = 99,
}

export enum WdykMode {
  Level3And4 = 3,
  Level5And6 = 5,
  Level7And8 = 8,
}

export enum ConjunctionType {
  And = 0,
  Or = 1,
}

export enum StatusLoginCreate {
  Success = 0,
  BadToken = 1,
  TokenExpired = 2,
  AccountExists = 3,
}

export enum Mode {
  None = 0,
  Automatic = 1,
  Manual = 2,
}

export enum StatusResetPassword {
  Success = 0,
  BadToken = 1,
  TokenExpired = 2,
  NoSuchAccount = 3,
}

export enum TimeOnTaskProgressType {
  Completed = 0,
  Mistake = 1,
  PreviewCompleted = 2,
  PreviewMistake = 3,
  Abandoned = 4,
}

export enum StatusShopping {
  NoSuchOrder = 0,
  OrderPending = 1,
  OrderFailed = 2,
  NoLoginCreated = 3,
  Success = 4,
}

export enum BonusGameFamily {
  GradePreK = 0,
  GradeKShapes = 1,
  GradeKNumbers = 2,
  GradeKComputationalThinking = 3,
  GradeKFirstInReadingLetters = 4,
  GradeKFirstInReadingWords = 5,
  GradeKFirstInReadingSentences = 6,
  Grade1 = 7,
  Grade2 = 8,
  Grade3 = 9,
  Grade4 = 10,
  Grade5 = 11,
  Grade6 = 12,
  Grade7 = 13,
  Grade8 = 14,
  ComputationalThinkingEarly = 15,
  ComputationalThinkingElementary = 16,
  ComputationalThinkingIntermediate = 17,
  AreaPerimeter = 18,
  MeasurementWorld = 19,
}

export enum VeryImportantFactsMode {
  AddSub = 0,
  MulDiv = 1,
  All = 2,
}

export enum StatusEmail {
  Pending = 0,
  Processing = 1,
  Sent = 2,
  Failed = 3,
  Opened = 4,
}

export enum FactStatus {
  Incorrect = 0,
  Correct = 1,
  Incomplete = 2,
}

export enum TeamTopPlayersType {
  AllTime = 0,
  Today = 1,
  Yesterday = 2,
  Week = 3,
  Month = 4,
}

export enum LoginMode {
  Auto = 'Auto',
  Manual = 'Manual',
}

export enum ChartSource {
  Dashboard = 'Dashboard',
}

export enum MetaKey {
  DashboardConfig = 0,
  AvatarConfig = 1,
  FavoriteModules = 2,
  PlayerAvatar = 3,
}

export enum AvatarType {
  Default = 0,
  Custom = 1,
}

export enum AvatarMetaKeys {
  BgColor = 'BgColor',
  AvatarIcon = 'AvatarIcon',
}

export enum MeasurementType {
  English,
  Metric,
  Mixed,
}

export enum PrePostMode {
  Pre,
  Post,
  Best,
}

/* eslint-disable @typescript-eslint/naming-convention */
export enum VifModuleInfo {
  none = 0,
  vif_add = 166,
  vif_sub = 167,
  vif_mul = 168,
  vif_div = 169,
  vif_add_rules = 170,
  vif_sub_rules = 171,
  vif_mul_rules = 172,
  vif_div_rules = 173,
  vif_add_redo = 174,
  vif_sub_redo = 175,
  vif_mul_redo = 176,
  vif_div_redo = 177,
  vif_add_rules_dd = 178,
  vif_sub_rules_dd = 179,
  vif_mul_rules_dd = 180,
  vif_div_rules_dd = 181,
}
/* eslint-enable @typescript-eslint/naming-convention */

export enum NotificationType {
  All,
  Unread,
  Read,
}

export enum FavoriteGamesAction {
  Add = 'Add',
  Remove = 'Remove',
}
